import { useState } from "react";
import Reveal from "./Reveal";
import { submitEnquiry } from "../hubspot";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Invite() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    countries: "",
    message: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [status, setStatus] = useState({ type: "idle" });

  const update = (event) =>
    setForm({ ...form, [event.target.name]: event.target.value });

  async function onSubmit(event) {
    event.preventDefault();
    const errors = {};
    if (form.name.trim().length < 2) {
      errors.name = "Please enter your name.";
    }
    if (!EMAIL_PATTERN.test(form.email.trim())) {
      errors.email = "Please enter a valid email address.";
    }
    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setStatus({ type: "sending" });
    try {
      await submitEnquiry(form);
      setStatus({ type: "success" });
    } catch (error) {
      setStatus({ type: "error" });
    }
  }

  return (
    <section className="band band-canvas" id="invite" data-testid="section-invite">
      <div className="container invite-grid">
        <Reveal>
          <div>
            <p className="eyebrow">Begin here</p>
            <h2>Begin with a private conversation.</h2>
            <p className="lede">
              Tell us a little about the family and the countries involved.
              One of the co-founders will reply personally, usually within two
              working days, to arrange a call.
            </p>
            <dl className="contact-block" data-testid="contact-block">
              <div>
                <dt className="fact-label">Email</dt>
                <dd className="contact-value">
                  <a
                    className="contact-value"
                    href="mailto:contact@globalcitizenconsult.com"
                    data-testid="contact-email"
                  >
                    contact@globalcitizenconsult.com
                  </a>
                </dd>
              </div>
              <div>
                <dt className="fact-label">Telephone</dt>
                <dd className="contact-value">
                  <a
                    className="contact-value"
                    href="tel:+18883227455"
                    data-testid="contact-phone"
                  >
                    +1 (888) 322-7455
                  </a>
                </dd>
              </div>
              <div>
                <dt className="fact-label">Offices</dt>
                <dd className="contact-value" data-testid="contact-offices">
                  Panama City · Dallas · Dubai · Madrid
                </dd>
              </div>
            </dl>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="form-card" data-testid="enquiry-form-card">
          {status.type === "success" ? (
            <div
              className="form-status"
              role="status"
              data-testid="form-status-success"
            >
              Thank you. Your message has reached the co-founders and one of
              us will reply personally.
            </div>
          ) : status.type === "error" ? (
            <div
              className="form-status form-status-error"
              role="alert"
              data-testid="form-status-error"
            >
              Something went wrong sending your message. Please email
              contact@globalcitizenconsult.com and we will reply the same way.
            </div>
          ) : (
            <form onSubmit={onSubmit} noValidate data-testid="enquiry-form">
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="name">Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    required
                    value={form.name}
                    onChange={update}
                    aria-invalid={fieldErrors.name ? "true" : "false"}
                    data-testid="form-name-input"
                  />
                  {fieldErrors.name && (
                    <p className="field-error" data-testid="form-name-error">
                      {fieldErrors.name}
                    </p>
                  )}
                </div>
                <div className="form-field">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={form.email}
                    onChange={update}
                    aria-invalid={fieldErrors.email ? "true" : "false"}
                    data-testid="form-email-input"
                  />
                  {fieldErrors.email && (
                    <p className="field-error" data-testid="form-email-error">
                      {fieldErrors.email}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-field">
                <label htmlFor="countries">Countries the family touches</label>
                <input
                  id="countries"
                  name="countries"
                  type="text"
                  placeholder="Residence, citizenship, companies, property"
                  value={form.countries}
                  onChange={update}
                  data-testid="form-countries-input"
                />
              </div>
              <div className="form-field">
                <label htmlFor="message">What prompted this</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="An exit, a move, a generation change, or something else"
                  value={form.message}
                  onChange={update}
                  data-testid="form-message-textarea"
                />
              </div>
              <button
                className="btn btn-primary form-submit"
                type="submit"
                disabled={status.type === "sending"}
                data-testid="form-submit-button"
              >
                Request a conversation
              </button>
              <p className="fine-print" data-testid="form-fine-print">
                Your message goes to the co-founders directly. Nothing you
                write here is shared outside the firm.
              </p>
            </form>
          )}
        </div>
        </Reveal>
      </div>
    </section>
  );
}
